import { SupplierType } from "../types";
import { ServiceEndpoints } from "../constants";
import { axios } from "./apiConfig";

// Fetch all suppliers
export const getSuppliers = async () => {
  return axios
    .get(ServiceEndpoints.SUPPLIERS)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Create a new supplier
export const createSupplier = async (data: SupplierType) => {
  return axios
    .post(ServiceEndpoints.SUPPLIERS, data)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Update an existing supplier
export const updateSupplier = async (id: string, data: SupplierType) => {
  const { ...supplierData } = data;

  return axios
    .put(`${ServiceEndpoints.SUPPLIERS}/${id}`, supplierData)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Get a supplier by its ID
export const getSupplierById = async (id: string) => {
  return axios
    .get(`${ServiceEndpoints.SUPPLIERS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

// Delete a supplier
export const deleteSupplier = async (id: string) => {
  return axios
    .delete(`${ServiceEndpoints.SUPPLIERS}/${id}`)
    .then(({ data }) => {
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};
